import { render, staticRenderFns } from "./OrgFields.vue?vue&type=template&id=24036b07"
import script from "./OrgFields.vue?vue&type=script&lang=js"
export * from "./OrgFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports